module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAwBAMAAAD5pqeQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUxpcf///////////////////////////////////9noCcoAAAAJdFJOUwDfIBDP7zBfkGws3T0AAABhSURBVCjPY2CgHDArIHFMhJAkPCcipExmzkRIKc6ciZBikiRXShgulTpz5hQDGIctcuZMZ2pLNcClKmfODMDKYZuJpAzZABSjKZNA8TZygKAEFVESqFGCElko0YgawZQBABpyQDkDurwmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (53).png
// module id = MjuT
// module chunks = 1